<script>
export default {
  functional: true,
  props: {
    useSide: Boolean,
    sideHandler: Function,
    title: String,
    btnIcon: String,
    btnHandler: Function,
    isLoading: Boolean,
  },
  render: (h, { props }) => {
    const {
      useSide,
      sideHandler,
      title,
      btnIcon,
      btnHandler,
      isLoading,
    } = props
    const side = useSide
      ? <v-toolbar-side-icon on-click={ e => { sideHandler() } }/>
      : ''
    const loader = isLoading
      ? <v-avatar>
        <v-progress-circular indeterminate/>
      </v-avatar>
      : null

    const doBtn = e => { btnHandler() }
    return (
      <v-toolbar-title class="ml-0 pl-3">
        { side }
        <v-btn icon on-click={ doBtn }>
          <v-icon>{ btnIcon }</v-icon>
        </v-btn>
        <span class="hidden-sm-and-down">{ title }</span>
        { loader }
      </v-toolbar-title>
    )
  },
}
</script>
